import { Auth } from 'aws-amplify';

const Helpers = {
  async httpRequest(url, method, payload, callback, failback, headers) {
  // set up initial configuration
    const conf = {
      method,
      headers: {
        Accept: 'application/json, text/plain, */*',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${await authorizationToken()}`,
      },
    };

    // if headers, overwrite headers
    if (headers) {
      conf.headers = headers;
    }

    // if post or put add payload
    if (method === 'post' || method === 'put') {
      conf.body = payload;
    }

    if (method === 'delete') {
      delete conf.headers.Accept;
      delete conf['Content-Type'];
    }

    try {
      const response = await fetch(url, conf);

      if (!response?.ok) {
        response.text().then((error) => {
          failback(JSON.parse(error));
        });
        return;
      }
      handleUnauthorizedRequest(response, url, conf)
        .then(async (handledResponse) => {
          if (callback) callback(await handledResponse.json());
        })
        .catch((error) => {
          if (failback) failback(error);
        });
    } catch (error) {
      if (failback) {
        failback(error);
      }
    }
  },
};

const handleUnauthorizedRequest = async (response, url, initialConfiguration) => {
  if (response.status === 403) {
    const result = await response.json();
    if (result.code === 'MFA_REQUIRED') {
      localStorage.removeItem('accessToken');
      window.location.href = '/login';
      return response;
    }
    if (result.message && result.message.length > 0) {
      if ((result.message.indexOf('Unauthorized') > -1)) {
        localStorage.removeItem('accessToken');
        window.location.href = '/login';
      } else {
        throw result;
      }
    } else {
      throw new Error(
        'You do not have access to this. Please contact the support in case something is wrong.',
      );
    }
  }

  if (response.status === 401) {
    // retry
    const updatedConfig = { ...initialConfiguration };

    const refreshedToken = await refreshToken();
    updatedConfig.headers.Authorization = `Bearer ${refreshedToken}`;

    return fetch(url, updatedConfig);
  }

  return response;
};

const authorizationToken = async () => localStorage.accessToken || tokenFromAmplifyAuth();

async function tokenFromAmplifyAuth() {
  return Auth.currentAuthenticatedUser()
    .then(({ signInUserSession }) => signInUserSession?.idToken?.jwtToken ?? '')
    .catch(() => '');
}

function refreshToken() {
  return Auth.currentAuthenticatedUser()
    .then(({ signInUserSession }) => {
      const { jwtToken } = signInUserSession.idToken ?? '';
      localStorage.setItem('accessToken', jwtToken);
      return Promise.resolve(jwtToken);
    })
    .catch(() => {
      window.location.reload();
    });
}

export default Helpers;
